// extracted by mini-css-extract-plugin
export var border = "_2i-7";
export var brand = "_2i-s";
export var button = "_2i-k";
export var center = "_2i-9";
export var centered = "_2i-5";
export var closeButton = "_2i-b";
export var disabledWrapper = "_2i-l";
export var error = "_2i-o";
export var extraLarge = "_2i-4";
export var extraSmall = "_2i-1";
export var fill = "_2i-h";
export var footer = "_2i-g";
export var footerAction = "_2i-i";
export var footerButtons = "_2i-j";
export var header = "_2i-6";
export var headerWithClose = "_2i-c";
export var icon = "_2i-n";
export var info = "_2i-r";
export var inline = "_2i-8";
export var large = "_2i-3";
export var main = "_2i-d";
export var modal = "_2i-0";
export var neutral = "_2i-t";
export var noPadding = "_2i-f";
export var none = "_2i-u";
export var scrollable = "_2i-e";
export var small = "_2i-2";
export var success = "_2i-q";
export var tight = "_2i-m";
export var titleIcon = "_2i-a";
export var warn = "_2i-p";